/* Broworkshop · componentes compartidos y animaciones */
(function () {
  'use strict';

  const BW = window.BW;
  const { $, $$, esc, norm, money, imgUrl, srcset, catMeta, Cart, Wish, icon, C } = BW;
  const ui = (BW.ui = BW.ui || {});

  document.documentElement.classList.add('js');

  /* ───────────── URLs ───────────── */
  const productUrl = (handle) => `${BW.R.product}${encodeURIComponent(handle)}`;
  const shopUrl = (params = {}) => BW.link(BW.R.shop, params);
  /** Atributos para abrir el formulario de contacto (en otra pestaña solo fuera de Shopify). */
  const contactAttrs = () => `href="${esc(C.contactUrl)}"${C.contactTarget === '_self' ? '' : ' target="_blank" rel="noopener"'}`;

  /* ───────────── Precio y tarjetas ───────────── */
  function priceHTML(price, compare = 0, cls = '') {
    const was = compare > price
      ? `<s class="price__was"><span class="sr">Antes </span>${money(compare)}</s>`
      : '';
    return `<div class="price ${cls}"><b class="price__now">${money(price)}</b>${was}</div>`;
  }

  function badgesHTML(p) {
    return [
      p.discount >= 1 ? `<span class="tag tag--sale">-${p.discount}%</span>` : '',
      p.bestPrice ? `<span class="tag tag--best">${icon('sparkle')}Mejor precio</span>` : '',
      !p.available ? '<span class="tag tag--out">Agotado</span>' : '',
    ].join('');
  }

  function card(p, i = 0, opts = {}) {
    const tone = catMeta(p.typeSlug).tone;
    const on = Wish.has(p.handle);
    const url = productUrl(p.handle);
    const ask = hasWhatsApp()
      ? `<a class="card__wa" href="${esc(waLink(askWaText(p)))}" target="_blank" rel="noopener"
          aria-label="Preguntar por WhatsApp: ${esc(p.title)}" title="Preguntar por WhatsApp">${icon('wa')}</a>`
      : '';
    const showVendor = p.vendor && norm(p.vendor) !== norm(C.storeName);
    const title = opts.q ? BW.highlight(p.title, opts.q) : esc(p.title);
    const delay = opts.noDelay ? 0 : Math.min(i, 11) * 45;
    const action = !p.available
      ? ''
      : p.variantId
        ? `<button class="card__add" type="button" data-add="${esc(p.variantId)}" data-handle="${esc(p.handle)}" aria-label="Agregar al carrito: ${esc(p.title)}">${icon('bag')}<span>Agregar</span></button>`
        : `<a class="card__add" href="${url}" aria-label="Elegir opciones: ${esc(p.title)}">${icon('eye')}<span>Elegir opciones</span></a>`;
    return `
    <article class="card" data-tilt data-reveal style="--d:${delay}ms">
      <div class="card__top">
        <div class="card__media tone-${tone}${p.image2 ? ' has-alt' : ''}">
          <img src="${imgUrl(p.image, 480)}" srcset="${srcset(p.image, [240, 360, 480, 720])}"
            sizes="(max-width: 640px) 46vw, (max-width: 1100px) 30vw, 280px"
            alt="${esc(p.alt)}" loading="lazy" decoding="async" width="480" height="480">
          ${p.image2 ? `<img class="card__img2" src="${imgUrl(p.image2, 480)}" alt="" loading="lazy" decoding="async">` : ''}
        </div>
        <div class="card__badges">${badgesHTML(p)}</div>
        <button class="card__wish${on ? ' is-on' : ''}" type="button" data-wish="${esc(p.handle)}"
          aria-pressed="${on}" aria-label="Guardar en favoritos: ${esc(p.title)}">${icon('heart')}</button>
        ${ask}
        ${action}
      </div>
      <div class="card__body">
        <p class="card__meta"><a href="${shopUrl({ cat: p.typeSlug })}">${esc(p.type)}</a>${showVendor ? ` · <span>${esc(p.vendor)}</span>` : ''}</p>
        <h3 class="card__title"><a href="${url}">${title}</a></h3>
        ${priceHTML(p.price, p.compare)}
        ${p.compare > p.price ? `<p class="card__save">${icon('tag')}Ahorras ${money(p.compare - p.price)}</p>` : ''}
      </div>
    </article>`;
  }

  /**
   * Sello de medios de pago. Sale de la configuración del tema y nunca guarda llaves:
   * el cobro lo hace la pasarela desde el checkout de Shopify.
   */
  function paymentsHTML(opts = {}) {
    const p = C.payments || {};
    if (p.show === false) return '';
    const list = Array.isArray(p.methods) ? p.methods : String(p.methods || '').split(',');
    const methods = list.map((m) => String(m).trim()).filter(Boolean);
    if (!methods.length && !p.gateway) return '';
    const label = p.gateway ? `Pago seguro procesado por ${esc(p.gateway)}` : 'Pago seguro';
    return `<div class="pay${opts.compact ? ' pay--compact' : ''}">
      <p class="pay__label">${icon('lock')}${label}</p>
      ${methods.length ? `<ul class="pay__chips">${methods.map((m) => `<li class="pay__chip">${esc(m)}</li>`).join('')}</ul>` : ''}
    </div>`;
  }

  const skeletons = (n = 8) => Array.from({ length: n }, () => `
    <div class="card card--skeleton" aria-hidden="true">
      <div class="card__media sk"></div>
      <div class="card__body"><span class="sk sk--line sk--short"></span><span class="sk sk--line"></span><span class="sk sk--line sk--mid"></span></div>
    </div>`).join('');

  function emptyState({ title, text = '', actions = '', art = 'bag', extra = '' }) {
    return `
    <div class="empty" data-reveal>
      <div class="empty__art" aria-hidden="true">
        <span class="empty__blob"></span>
        <span class="empty__icon">${icon(art)}</span>
        <span class="empty__spark s1">${icon('sparkle')}</span>
        <span class="empty__spark s2">${icon('sparkle')}</span>
      </div>
      <h3>${title}</h3>
      ${text ? `<p>${text}</p>` : ''}
      ${actions ? `<div class="empty__actions">${actions}</div>` : ''}
      ${extra}
    </div>`;
  }

  function marquee(inner, { speed = 40, reverse = false, cls = '' } = {}) {
    return `
    <div class="marquee ${cls}${reverse ? ' marquee--rev' : ''}" style="--speed:${speed}s">
      <div class="marquee__track">
        <div class="marquee__group">${inner}</div>
        <div class="marquee__group" aria-hidden="true" inert>${inner}</div>
      </div>
    </div>`;
  }

  /* ───────────── Notificaciones (toasts) ───────────── */
  function toastHost() {
    let host = $('.toasts');
    if (!host) {
      host = document.createElement('div');
      host.className = 'toasts';
      host.setAttribute('role', 'status');
      host.setAttribute('aria-live', 'polite');
      document.body.appendChild(host);
    }
    return host;
  }

  function toast({ title, text = '', image = '', type = 'success', action = null, timeout = 4200 }) {
    const host = toastHost();
    const el = document.createElement('div');
    const ic = { success: 'check', error: 'alert', wish: 'heart', info: 'info' }[type] || 'info';
    el.className = `toast toast--${type}`;
    el.style.setProperty('--life', `${timeout}ms`);
    el.innerHTML = `
      ${image ? `<img class="toast__img" src="${imgUrl(image, 120)}" alt="">` : `<span class="toast__icon">${icon(ic)}</span>`}
      <div class="toast__body"><b>${esc(title)}</b>${text ? `<span>${esc(text)}</span>` : ''}</div>
      ${action ? `<button class="toast__action" type="button">${esc(action.label)}</button>` : ''}
      <button class="toast__close" type="button" aria-label="Cerrar aviso">${icon('x')}</button>
      <i class="toast__life" aria-hidden="true"></i>`;
    const close = () => {
      el.classList.add('is-leaving');
      setTimeout(() => el.remove(), 320);
    };
    el.querySelector('.toast__close').addEventListener('click', close);
    if (action) el.querySelector('.toast__action').addEventListener('click', () => { action.run(); close(); });
    host.appendChild(el);
    while (host.children.length > 3) host.firstElementChild.remove();
    let timer = setTimeout(close, timeout);
    el.addEventListener('pointerenter', () => { clearTimeout(timer); el.classList.add('is-paused'); });
    el.addEventListener('pointerleave', () => { el.classList.remove('is-paused'); timer = setTimeout(close, 1800); });
    return el;
  }

  /* ───────────── Aparición al hacer scroll y contadores ───────────── */
  const hasIO = 'IntersectionObserver' in window;
  const revealIO = hasIO && new IntersectionObserver((entries) => {
    entries.forEach((en) => {
      if (!en.isIntersecting) return;
      en.target.classList.add('is-in');
      revealIO.unobserve(en.target);
    });
  }, { rootMargin: '0px 0px -5% 0px', threshold: 0 });

  function countUp(el) {
    el.classList.add('is-counted');
    const target = Number(el.dataset.count) || 0;
    const fmt = (n) => `${el.dataset.prefix || ''}${Math.round(n).toLocaleString('es-CO')}${el.dataset.suffix || ''}`;
    if (!BW.motionOK()) { el.textContent = fmt(target); return; }
    const t0 = performance.now();
    const dur = 1500;
    const step = (t) => {
      const k = Math.min(1, (t - t0) / dur);
      el.textContent = fmt(target * (1 - Math.pow(1 - k, 3)));
      if (k < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }
  const countIO = hasIO && new IntersectionObserver((entries) => {
    entries.forEach((en) => {
      if (!en.isIntersecting) return;
      countUp(en.target);
      countIO.unobserve(en.target);
    });
  }, { threshold: 0.4 });

  function reveal(root = document) {
    $$('[data-reveal]:not(.is-in)', root).forEach((el) => {
      if (revealIO && BW.motionOK()) revealIO.observe(el);
      else el.classList.add('is-in');
    });
    $$('[data-count]:not(.is-counted)', root).forEach((el) => {
      if (countIO) countIO.observe(el);
      else countUp(el);
    });
  }

  /* ───────────── Efecto onda (ripple) en botones ───────────── */
  document.addEventListener('pointerdown', (e) => {
    const host = e.target.closest('.btn, .chip, .card__add');
    if (!host || !BW.motionOK()) return;
    const r = host.getBoundingClientRect();
    const size = Math.max(r.width, r.height) * 2.2;
    const s = document.createElement('span');
    s.className = 'ripple';
    s.style.cssText = `width:${size}px;height:${size}px;left:${e.clientX - r.left - size / 2}px;top:${e.clientY - r.top - size / 2}px`;
    host.appendChild(s);
    s.addEventListener('animationend', () => s.remove());
  });

  /* ───────────── Inclinación 3D y botones magnéticos ───────────── */
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  let tiltEl = null;
  let magEl = null;
  let frame = 0;
  let lastMove = null;

  function resetTilt(el) {
    el.classList.remove('is-tilting');
    el.style.removeProperty('--rx');
    el.style.removeProperty('--ry');
  }
  function resetMag(el) { el.style.removeProperty('--mx'); el.style.removeProperty('--my'); }

  document.addEventListener('pointermove', (e) => {
    if (!finePointer.matches || !BW.motionOK()) return;
    lastMove = e;
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      const target = lastMove.target instanceof Element ? lastMove.target : null;
      const t = target && target.closest('[data-tilt]');
      if (tiltEl && tiltEl !== t) resetTilt(tiltEl);
      tiltEl = t;
      if (t) {
        const r = t.getBoundingClientRect();
        const x = (lastMove.clientX - r.left) / r.width - 0.5;
        const y = (lastMove.clientY - r.top) / r.height - 0.5;
        t.style.setProperty('--rx', `${(-y * 5).toFixed(2)}deg`);
        t.style.setProperty('--ry', `${(x * 7).toFixed(2)}deg`);
        t.style.setProperty('--gx', `${((x + 0.5) * 100).toFixed(1)}%`);
        t.style.setProperty('--gy', `${((y + 0.5) * 100).toFixed(1)}%`);
        t.classList.add('is-tilting');
      }
      const m = target && target.closest('[data-magnetic]');
      if (magEl && magEl !== m) resetMag(magEl);
      magEl = m;
      if (m) {
        const r = m.getBoundingClientRect();
        m.style.setProperty('--mx', `${((lastMove.clientX - r.left - r.width / 2) * 0.18).toFixed(1)}px`);
        m.style.setProperty('--my', `${((lastMove.clientY - r.top - r.height / 2) * 0.25).toFixed(1)}px`);
      }
    });
  }, { passive: true });
  document.addEventListener('pointerout', (e) => {
    if (e.relatedTarget) return;
    if (tiltEl) resetTilt(tiltEl);
    if (magEl) resetMag(magEl);
    tiltEl = magEl = null;
  });

  /* ───────────── Carruseles horizontales (flechas + arrastre) ───────────── */
  function scroller(root) {
    const track = $('[data-track]', root);
    if (!track) return null;
    const prev = $('[data-prev]', root);
    const next = $('[data-next]', root);
    const update = () => {
      const max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
    };
    const by = (dir) => track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: BW.motionOK() ? 'smooth' : 'auto' });
    if (prev) prev.addEventListener('click', () => by(-1));
    if (next) next.addEventListener('click', () => by(1));
    track.addEventListener('scroll', BW.debounce(update, 50), { passive: true });
    window.addEventListener('resize', BW.debounce(update, 120));

    let down = false;
    let moved = false;
    let startX = 0;
    let startLeft = 0;
    track.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      down = true; moved = false; startX = e.clientX; startLeft = track.scrollLeft;
    });
    window.addEventListener('pointermove', (e) => {
      if (!down) return;
      const dx = e.clientX - startX;
      if (!moved && Math.abs(dx) > 6) { moved = true; track.classList.add('is-dragging'); }
      if (moved) track.scrollLeft = startLeft - dx;
    });
    window.addEventListener('pointerup', () => {
      if (!down) return;
      down = false;
      track.classList.remove('is-dragging');
    });
    track.addEventListener('click', (e) => {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
    track.addEventListener('dragstart', (e) => e.preventDefault());
    requestAnimationFrame(update);
    return { update };
  }

  /* ───────────── Carrito: animación "vuela al carrito" ───────────── */
  function visibleCartTarget() {
    return $$('[data-cart-target]').find((el) => {
      const r = el.getBoundingClientRect();
      return r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < window.innerHeight;
    });
  }

  function bump(el) {
    if (!el) return;
    el.classList.remove('is-bump');
    void el.offsetWidth;
    el.classList.add('is-bump');
  }

  function flyToCart(imgEl) {
    const target = visibleCartTarget();
    if (!imgEl || !target || !BW.motionOK() || document.hidden) { bump(target); return Promise.resolve(); }
    const a = imgEl.getBoundingClientRect();
    const b = target.getBoundingClientRect();
    if (!a.width) { bump(target); return Promise.resolve(); }
    const size = Math.min(a.width, a.height, 200);
    const ghost = document.createElement('img');
    ghost.src = imgEl.currentSrc || imgEl.src;
    ghost.alt = '';
    ghost.className = 'fly-ghost';
    Object.assign(ghost.style, {
      left: `${a.left + (a.width - size) / 2}px`,
      top: `${a.top + (a.height - size) / 2}px`,
      width: `${size}px`,
      height: `${size}px`,
    });
    document.body.appendChild(ghost);
    const dx = b.left + b.width / 2 - (a.left + a.width / 2);
    const dy = b.top + b.height / 2 - (a.top + a.height / 2);
    const anim = ghost.animate([
      { transform: 'translate(0, 0) scale(1) rotate(0deg)', opacity: 1 },
      { transform: `translate(${dx * 0.3}px, ${dy * 0.3 - 90}px) scale(.72) rotate(-8deg)`, opacity: 1, offset: 0.42 },
      { transform: `translate(${dx}px, ${dy}px) scale(.12) rotate(14deg)`, opacity: 0.35 },
    ], { duration: 850, easing: 'cubic-bezier(.45,.05,.35,1)' });
    // Si la pestaña pasa a segundo plano la animación se congela: no dejar el botón bloqueado por eso
    const timeout = new Promise((resolve) => setTimeout(resolve, 1200));
    return Promise.race([anim.finished.catch(() => {}), timeout]).then(() => { ghost.remove(); bump(target); });
  }

  function busy(btn, on) {
    if (!btn) return;
    btn.classList.toggle('is-busy', on);
    btn.setAttribute('aria-busy', String(on));
    if (btn.tagName === 'BUTTON') btn.disabled = on;
  }

  function done(btn) {
    if (!btn) return;
    btn.classList.add('is-done');
    setTimeout(() => btn.classList.remove('is-done'), 1600);
  }

  async function addToCart(variantId, { qty = 1, button = null, image = null, product = null, openCart = false } = {}) {
    busy(button, true);
    try {
      await Promise.all([Cart.add(variantId, qty), flyToCart(image)]);
      done(button);
      if (openCart && ui.openDrawer) ui.openDrawer('cart');
      else {
        toast({
          title: '¡Agregado al carrito!',
          text: product ? product.title : '',
          image: product ? product.image : '',
          action: { label: 'Ver carrito', run: () => ui.openDrawer && ui.openDrawer('cart') },
        });
      }
      return true;
    } catch (err) {
      console.error(err);
      toast({ type: 'error', title: 'No pudimos agregarlo', text: 'Revisa tu conexión e inténtalo de nuevo.' });
      return false;
    } finally {
      busy(button, false);
    }
  }

  /* ───────────── Favoritos ───────────── */
  function burst(el) {
    if (!BW.motionOK() || !el) return;
    const r = el.getBoundingClientRect();
    const wrap = document.createElement('span');
    wrap.className = 'burst';
    wrap.style.left = `${r.left + r.width / 2}px`;
    wrap.style.top = `${r.top + r.height / 2}px`;
    for (let i = 0; i < 9; i++) {
      const s = document.createElement('i');
      s.style.setProperty('--a', `${i * 40}deg`);
      wrap.appendChild(s);
    }
    document.body.appendChild(wrap);
    setTimeout(() => wrap.remove(), 800);
  }

  function syncWishButtons(root = document) {
    $$('[data-wish]', root).forEach((b) => {
      const on = Wish.has(b.dataset.wish);
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', String(on));
    });
  }

  function toggleWish(handle, btn) {
    const p = BW.index.get(handle) || Wish.items.find((i) => i.handle === handle);
    if (!p) return;
    const on = Wish.toggle(p);
    if (btn) {
      btn.classList.remove('is-pop');
      void btn.offsetWidth;
      btn.classList.add('is-pop');
      if (on) burst(btn);
    }
    toast({
      type: on ? 'wish' : 'info',
      title: on ? 'Guardado en favoritos' : 'Quitado de favoritos',
      text: p.title,
      image: p.image,
      timeout: 2800,
      action: on ? { label: 'Ver', run: () => ui.openDrawer && ui.openDrawer('wish') } : null,
    });
  }
  Wish.subscribe(() => syncWishButtons());

  /* ───────────── Clics delegados ───────────── */
  document.addEventListener('click', (e) => {
    const wish = e.target.closest('[data-wish]');
    if (wish) {
      e.preventDefault();
      toggleWish(wish.dataset.wish, wish);
      return;
    }
    const add = e.target.closest('[data-add]');
    if (add) {
      e.preventDefault();
      if (add.classList.contains('is-busy')) return;
      const handle = add.dataset.handle;
      const product = BW.index.get(handle) || Wish.items.find((i) => i.handle === handle) || null;
      const scope = add.closest('[data-product-scope], .card, .mini');
      const image = scope ? scope.querySelector('img') : null;
      addToCart(add.dataset.add, { button: add, image, product });
    }
  });

  /* ───────────── WhatsApp ───────────── */
  const waNumber = () => String(C.whatsapp || '').replace(/\D/g, '');
  const hasWhatsApp = () => waNumber().length >= 10;
  const waPretty = () => {
    const d = waNumber();
    return d.length === 12 && d.startsWith('57') ? `+57 ${d.slice(2, 5)} ${d.slice(5, 8)} ${d.slice(8)}` : `+${d}`;
  };
  const cleanPath = () => window.location.pathname.replace(/\/index(\.html)?$/, '/');
  /** Dirección pública (www) de la página actual, sin importar desde dónde se esté viendo. */
  const pageUrl = () => `${C.publicUrl.replace(/\/$/, '')}${cleanPath()}${window.location.search}`;
  /** Convierte una ruta del sitio en una dirección completa para pegarla en WhatsApp. */
  const absUrl = (path) => {
    try { return new URL(path, `${C.publicUrl.replace(/\/$/, '')}/`).href; } catch { return path; }
  };
  /** Mensaje para preguntar por un producto puntual desde el catálogo. */
  const askWaText = (p) => [
    '¡Hola Broworkshop! 👋 Quiero información sobre este producto:',
    `*${p.title}*`,
    `Precio: ${money(p.price)}`,
    absUrl(productUrl(p.handle)),
  ].join('\n');
  const waLink = (text) => (hasWhatsApp() ? `https://wa.me/${waNumber()}?text=${encodeURIComponent(text)}` : '');
  let waText = '';
  const currentWaText = () => {
    if (waText) return waText;
    const home = cleanPath() === '/' && !window.location.search;
    return home ? C.whatsappMessage : `${C.whatsappMessage}\n${pageUrl()}`;
  };
  /** Cambia el mensaje de todos los botones de WhatsApp de la página ([data-wa]) y, si quieres, el del saludo. */
  function setWhatsApp(text, bubbleText) {
    waText = text || '';
    $$('[data-wa]').forEach((a) => { a.href = waLink(currentWaText()); });
    if (bubbleText) $$('[data-wa-msg]').forEach((el) => { el.textContent = bubbleText; });
  }

  /** Reemplaza <i data-icon="nombre"></i> del HTML estático por su SVG. */
  function hydrateIcons(root = document) {
    $$('i[data-icon]', root).forEach((el) => {
      el.outerHTML = icon(el.dataset.icon, el.className);
    });
  }
  hydrateIcons();

  Object.assign(ui, {
    hydrateIcons,
    hasWhatsApp, waPretty, waLink, pageUrl, absUrl, askWaText, currentWaText, setWhatsApp,
    productUrl, shopUrl, contactAttrs, priceHTML, badgesHTML, card, skeletons, emptyState, marquee, paymentsHTML,
    toast, reveal, scroller, flyToCart, bump, busy, done, addToCart, toggleWish, syncWishButtons, burst,
  });
})();
